import { Component, OnInit } from '@angular/core';
import { AssortmentService, Assortment } from 'gung-standard';

@Component({
    selector: 'ref-ref-categories',
    templateUrl: './ref-categories.component.html',
    styleUrls: ['./ref-categories.component.scss'],
    standalone: false
})
export class RefCategoriesComponent implements OnInit {
  public assortment: Assortment;
  public subAssortments: Assortment[];

  constructor(private assortmentService: AssortmentService) {}

  ngOnInit() {
    this.assortmentService.getUserAssortment().subscribe(assortment => {
      this.assortment = assortment;

      this.subAssortments = assortment.children;
    });
  }
}
